<template>
  <div id='hand'>
    <img class='top_img' src="@/assets/images/hand/top.png" alt="">
    <div class='main'>
      <div class="tab">
        <p :class="{'on': tabBol}" @click='tabFun(true)'>本周榜单</p>
        <p :class="{'on': !tabBol}" @click='tabFun(false)'>上周榜单</p>
      </div>
      <div class="countdown">
        <p>本周榜单结算倒计时:<span>{{timestr}}</span></p>
      </div>
      <ul class="list">
        <li v-for="(item, index) in showList" :key=index>
          <div class="list_num">
            <img v-if='index==0' src="@/assets/images/hand/num1.png" alt="">
            <img v-if='index==1' src="@/assets/images/hand/num2.png" alt="">
            <img v-if='index==2' src="@/assets/images/hand/num3.png" alt="">
            <span v-if='index>2'>{{index+1}}</span>
          </div>
          <div class="list_user_img">
            <!-- @/assets/images/hand/null.png -->
            <div>
              <!-- 主播头像 -->
              <img :src="item.dstheadimage?item.dstheadimage:img" alt="">
              <img class="woman" src="@/assets/images/hand/woman.png" alt="">
            </div>
            <div>
              <!-- 用户头像 -->
              <img :src="item.srcheadimage?item.srcheadimage:img" alt="">
              <!-- <img v-if='item.status==0' src="@/assets/images/hand/null.png" alt=""> -->
              <img class="man" src="@/assets/images/hand/man.png" alt="">
            </div>
          </div>
          <div class='list_user_name'>
            <p class="list_user_name_p" v-if='item.dstnicname'>
              <em>{{item.dstnicname}}</em> <img src="@/assets/images/hand/heart.png" alt=""> <span>
                {{item.srcnickname}}
              </span>
            </p>
            <p class="list_user_name_p" v-if='!item.dstnicname'>
              虚位以待
            </p>
            <div>
              <img src="@/assets/images/hand/head.png" alt="">
              <p>{{item.score || 1000}}</p>
            </div>
          </div>
        </li>
      </ul>
      <img class="explain" src="@/assets/images/hand/explain.png?2021011303" alt="">
      <img @click='goRoom' v-if='typeBol' class="btn" src="@/assets/images/hand/button.png" alt="">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { get } from '@/http/index.js'
import { getQueryString } from '@/utils/index.js'
import api from '@/http/api'
export default {
  name: 'hand',
  data () {
    return {
      tabBol: true,
      thisWeek: {},
      lastWeek: {},
      showList: [],
      typeBol: false,
      url: '',
      rid: '',
      timestr: '',
      img: require('../assets/images/hand/null.png')
    }
  },
  components: {
  },
  created () {
  },
  async mounted () {
    document.title = '甜蜜牵手'
    let that = this
    setTimeout(() => {
      if (window.winOcx.getUserData) {
        window.winOcx.getUserData(function(data){
          sessionStorage.setItem('initData', JSON.stringify(data))
          that.getRankInfoHttp(2)
          that.getRankInfoHttp(3)
          if (getQueryString('type') == '1') {
            that.typeBol = false
          } else {
            get(api.getRecommendRid, '', true).then(res => {
              if (res.code == 200) {
                let { rid } = res.data
                that.rid = rid
                that.typeBol = true
              }
            })
          }
          let actType = getQueryString('actType')
          console.log(actType)
          console.log(location.href)
          if (actType) {
            that.handleHttp(actType)
          }
        })
      }
    }, 1000);
    // await this.getRankInfoHttp(2)
    // await this.getRankInfoHttp(3)
    // if (getQueryString('type') != '1') {
    //   this.typeBol = false
    // } else {
    //   get(api.getRecommendRid).then(res => {
    //     if (res.code == 200) {
    //       let { rid } = res.data
    //       this.rid = rid
    //       this.typeBol = true
    //     }
    //   })
    // }
  },
  methods: {
    tabFun (bol) {
      this.tabBol = bol
      if (bol) {
        this.showList = this.thisWeek.list
      } else {
        this.showList = this.lastWeek.list
      }
    },
    getRankInfoHttp (type) {
      get(api.getRankInfo, '&type='+type, true).then(res => {
        if (res.code == 200) {
          let { list, endtime } = res.data
          if (list.length>10) {
            res.data.list = list.slice(0,10)
          }
          if (list.length<10) {
            let num = 10-list.length
            for (let i=0; i<num; i++) {
              res.data.list.push([])
            }
          }
          if (endtime) {
            this.leftTimer(Number(endtime+'000'))
          }
          if (type == 2) {
            this.thisWeek = res.data
            this.showList = res.data.list
          } else {
            this.lastWeek = res.data
          }
        }
      })
    },
    goRoom () {
      let { rid } = this
      console.log(rid)
      this.handleHttp('10011')
      window.winOcx.openPage('room',{
        'rid' :rid,
        'status' :1
      });
    },
    leftTimer(time){
      var leftTime = (new Date(time)) - (new Date())
      var days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10)
      var hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10)
      var minutes = parseInt(leftTime / 1000 / 60 % 60, 10)
      var seconds = parseInt(leftTime / 1000 % 60, 10)
      hours = this.checkTime(hours)
      minutes = this.checkTime(minutes)
      seconds = this.checkTime(seconds)
      setTimeout(() => {
          this.leftTimer(time)
      }, 1000)
      this.timestr=days+"天" + hours+":" + minutes+":"+seconds
    },
    checkTime(i){ //将0-9的数字前面加上0，例1变为01
      if(i<10)
      {
      i = "0" + i
      }
      return i
    },
    handleHttp (str) {
      get('/ajax/click/handle', '&cid='+str, true)
    }
  }
}
</script>
<style lang="scss" scope>
  @mixin font($size, $color){
    color: $color;
    font-size: $size
  }
  #hand{
    background: #462495;
    padding-bottom: 71px;
    .top_img{
      width: 100%;
    }
    .main{
      border: 7px solid #783df6;
      border-radius: 23px;
      background: #4423a2;
      margin: -55px 17px 0 17px;
      position: relative;
      z-index: 1;
      padding-bottom: 21px;
    }
    .tab{
      width: 410px;
      height: 60px;
      margin: 45px auto 0 auto;
      background: url(../assets/images/hand/tab_bg.png);
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      p{
        width: 200px;
        height: 55px;
        margin: 2px 3.4px 0 0;
        text-align: center;
        line-height: 60px;
        color: #C7C1FF;
        font-size: 28px;
        font-weight: 700;
      }
      .on{
        background: url(../assets/images/hand/button_bg.png);
        background-size: 100% 100%;
        color: #913219;
      }
    }
    .countdown{
      margin: 24px 0 0 12px;
      line-height: 24px;
      @include font(24px, #C7C1FF);
      p{
        @include font(24px, #C7C1FF);
      }
      span{
        color: #fff;
        @include font(24px, #C7C1FF);
      }
    }
    .list{
      margin-top: 28px;
      li:nth-child(odd){
        background: rgba(171, 107, 181, .2);
      }
      li:nth-child(even) {
        background: rgba(171, 107, 181, .1);
      }
    }
    .list li{
      display: flex;
      height: 120px;
    }
    .list_num{
      width: 64px;
      margin-left: 34px;
      img{
        width: 100%;
        height: 36px;
        margin-top: 42px;
      }
      span{
        display: block;
        width: 40px;
        height: 40px;
        background: linear-gradient(26deg,#de4680 0%, #ff9dc3 100%);
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        @include font(24px, #fff);
        margin-top: 40px;
        margin-left: 11px;
      }
    }
    .list_user_img{
      display: flex;
      margin-top: 26.7px;
      position: relative;
      margin-left: 37.69px;
      img{
        width: 64.63px;
        height: 64.63px;
      }
      div img:nth-child(1) {
        border-radius: 50%;
      }
      .woman{
        position: absolute;
        left: 0;
        top: 0;
      }
      .man{
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    .list_user_name{
      flex: 1;
      text-align: right;
      margin-right: 32px;
      div{
        display: flex;
        justify-content: flex-end;
        margin-top: 17px;
        img{
          width: 32px;
          height: 26px;
        }
        p{
          @include font(24px, #C7C1FF);
          line-height: 26px;
        }
      }
    }
    .list_user_name_p{
      @include font(24px, #fff);
      font-weight: 700;
      line-height: 37px;
      margin-top: 20px;
      display:flex;
      justify-content:flex-end;
      align-items: center;
      span{
        max-width: 150px;
        line-height: 37px;
        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        @include font(24px, #fff);
      }
      em{
        max-width: 200px;
        line-height: 37px;
        overflow:hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
        @include font(24px, #fff);
      }
      img{
        width: 24px;
        height: 19px;
      }
    }
    .explain{
      width: 638px;
      margin: 69px 32px 0 32px;
    }
    .btn{
      width: 457px;
      margin: 42.87px 128px 0 128px;
    }
  }
</style>
